const venueTemplate = require('../../templates').venueTemplate;
const roomTemplate = require('../../templates').roomTemplate;

const venueData = Object.assign({}, venueTemplate, {
	id: 'enigmarium',
	name: 'Enigmarium',	
	website: 'https://enigmarium.dk/',
	locations: [
		{
			id: 'blaavand',
			cityId: 'blaavand',
			opened: '20260604',
			closed: null,
			address: 'Skallingevej 5, 6857 Blåvand',
			coordinates: {lat: '55.54677861733907', lng: '8.227568324688805'},
		},
	],
	rooms: [
		Object.assign({}, roomTemplate, {
			id: 'the-wondrous-machine',
			name: {da: 'The Wondrous Machine', en: 'The Wondrous Machine'},			
			languages: ['da', 'en', 'de'],
			playtime: 75,
			teamSizeMin: 2,
			teamSizeMax: 6,
			locations: [{
				locationId: 'blaavand',
				opened: '20260604',
				closed: null,
				rooms: 1
			}]
		}),
		Object.assign({}, roomTemplate, {
			id: 'ludvigs-kitchen',
			name: {da: 'Ludvigs Køkken', en: 'Ludvigs Kitchen'},
			languages: ['da', 'en', 'de'],
			playtime: 75,
			teamSizeMin: 2,
			teamSizeMax: 6,
			locations: [{
				locationId: 'blaavand',
				opened: '20260604',
				closed: null,
				rooms: 1
			}]
		}),
	]
});


export {venueData};